export default {
    data: [
        'Môi giới',
        'Chính chủ',
        'Treo bảng'
    ]
}